import { Stack, ContentCard, Button } from '@forwardflow/ui-v2'
import { StageInputList } from '@forwardflow/modules/onboarding'
import { IStage, useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import {
   TStageGroupId,
   TStopStageKey,
} from '@forwardflow/types/onboarding'
import cn from 'classnames'

interface StageMapGroupProps {
   title?: string
   description?: string
   groupId: TStageGroupId | TStopStageKey
   shouldAddDescription?: boolean
   isOptional?: boolean
   allowAddStage?: boolean
   transitionDelay?: number
   hasBorder?: boolean
}

export const StageMapGroup = ({
   title,
   description,
   groupId,
   shouldAddDescription = false,
   isOptional = false,
   allowAddStage = false,
   transitionDelay = 0.0,
   hasBorder = true,
}: StageMapGroupProps) => {
   const { getTempStagesByGroupId, setTempStagesByGroupId } =
      useOnboardingStoreV2()
   const savedStages = getTempStagesByGroupId(groupId)

   const handleStagesChange = (value: IStage, index: number) => {
      const newStages = [...savedStages]
      newStages[index] = value
      setTempStagesByGroupId(groupId, newStages)
   }

   const handleAddStage = () => {
      const newStages = [
         ...savedStages,
         {
            id: '',
            name: '',
            description: '',
         },
      ]
      setTempStagesByGroupId(groupId, newStages)
   }

   const handleRemoveStage = (index: number) => {
      const newStages = [...savedStages]
      newStages.splice(index, 1)
      setTempStagesByGroupId(groupId, newStages)
   }

   return (
      <ContentCard
         className={cn("space-y-4", {
            "border-none !p-0 !bg-transparent": !hasBorder,
         })}
         initial={{ opacity: 0, y: 30 }}
         animate={{ opacity: 1, y: 0 }}
         transition={{ duration: 0.3, delay: transitionDelay }}
      >
         {title && <Stack gap={4}>
            {title && <p className="text-white font-medium">
               {title}{' '}
               {isOptional && (
                  <span className="text-[#99A1AF] text-sm font-medium">
                     (Optional)
                  </span>
               )}
            </p>}
            {description && (
               <p className="text-[#99A1AF] text-sm font-medium max-w-[600px]">
                  {description}
               </p>
            )}
         </Stack>}

         <StageInputList
            stages={savedStages}
            onChange={handleStagesChange}
            shouldAddDescription={shouldAddDescription}
            onRemoveStage={(index) => handleRemoveStage(index)}
         />
         {allowAddStage && (
            <Button
               variant="secondary"
               className="w-full"
               onClick={handleAddStage}
            >
               Add another stage
            </Button>
         )}
      </ContentCard>
   )
}
